export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0,0)`)
      .style('font-family', 'roboto')
      .attr('cursor', 'default')

      if(this.title.visible == 'Y') this.draw_Title(this.canvasForms)
      if(this.summary.visible == 'Y') {
        if(this.summary.display == 'horizontal') this.value_Horizontal(this.canvasForms)
        if(this.summary.display == 'vertical') this.value_Vertical(this.canvasForms)
      }
      this.Chart_Gauge(this.canvasForms)

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },

  }
}